import { render, staticRenderFns } from "./BasePDFRenderExam.vue?vue&type=template&id=5a4e9164&scoped=true&"
import script from "./BasePDFRenderExam.vue?vue&type=script&lang=js&"
export * from "./BasePDFRenderExam.vue?vue&type=script&lang=js&"
import style0 from "./BasePDFRenderExam.vue?vue&type=style&index=0&id=5a4e9164&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4e9164",
  null
  
)

export default component.exports